import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { AnimTimeConstant, EaseAnimation } from './Constants';
export var useFirstRunNavButtonStyles = makeStyles({
    container: __assign(__assign(__assign({ opacity: 1, height: '32px', width: '32px' }, shorthands.borderWidth(0)), shorthands.padding(0)), { backgroundColor: 'transparent', cursor: 'pointer', zIndex: 201, transitionDuration: AnimTimeConstant, transitionProperty: 'all', msTransitionTimingFunction: EaseAnimation, bottom: '12px', position: 'absolute' }),
    hidden: {
        visibility: 'hidden',
        opacity: 0,
        pointerEvents: 'none',
    },
    positionLeft: {
        left: '16px',
        '@media (min-width: 480px)': {
            marginRight: '24px',
            marginLeft: '2px',
            position: 'static',
        },
    },
    positionRight: {
        right: '16px',
        '@media (min-width: 480px)': {
            marginLeft: '24px',
            marginRight: '2px',
            position: 'static',
        },
    },
    background: __assign(__assign(__assign(__assign(__assign({ boxSizing: 'border-box', position: 'relative', width: '32px', height: '32px' }, shorthands.borderStyle('solid')), shorthands.borderWidth(tokens.strokeWidthThin)), shorthands.borderColor(tokens.colorTransparentStroke)), shorthands.borderRadius(tokens.borderRadiusCircular)), { backgroundColor: tokens.colorNeutralBackground1, ':hover': __assign({ backgroundColor: tokens.colorNeutralBackground1Hover }, shorthands.borderColor(tokens.colorTransparentStrokeInteractive)), ':active': __assign({ backgroundColor: tokens.colorNeutralBackground1Pressed }, shorthands.borderColor(tokens.colorTransparentStrokeInteractive)), ':disabled': __assign({ backgroundColor: tokens.colorNeutralBackgroundDisabled }, shorthands.borderColor(tokens.colorTransparentStrokeDisabled)), '@media (min-width: 480px)': {
            boxShadow: tokens.shadow4,
            ':hover': {
                boxShadow: tokens.shadow8,
            },
            ':disabled': {
                boxShadow: tokens.shadow2,
            },
        } }),
    arrowIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        color: tokens.colorNeutralForeground3,
        ':hover': {
            color: tokens.colorNeutralForeground3BrandHover,
        },
        ':active': {
            color: tokens.colorNeutralForeground3BrandPressed,
        },
        ':disabled': {
            backgroundColor: tokens.colorNeutralForegroundDisabled,
        },
    },
});
//# sourceMappingURL=FirstRunNavButton.styles.js.map